interface Props {
  [key: string]: any
}
function BriefcaseThinIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 20 20" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M18.8593 12.1655C16.0189 13.314 12.9833 13.9026 9.9195 13.8988C6.7578 13.8988 3.74113 13.283 0.979736 12.1655H18.8593ZM13.8927 4.95907V2.97245C13.8927 2.44557 13.6834 1.94027 13.3109 1.56771C12.9383 1.19514 12.433 0.98584 11.9061 0.98584H7.93288C7.406 0.98584 6.9007 1.19514 6.52814 1.56771C6.15557 1.94027 5.94627 2.44557 5.94627 2.97245V4.95907H13.8927ZM9.9195 10.9189H9.92943H9.9195ZM2.96635 18.8654H16.8726C17.3995 18.8654 17.9048 18.6561 18.2774 18.2835C18.65 17.9109 18.8593 17.4056 18.8593 16.8787V6.94568C18.8593 6.4188 18.65 5.91349 18.2774 5.54093C17.9048 5.16837 17.3995 4.95907 16.8726 4.95907H2.96635C2.43947 4.95907 1.93416 5.16837 1.5616 5.54093C1.18904 5.91349 0.979736 6.4188 0.979736 6.94568V16.8787C0.979736 17.4056 1.18904 17.9109 1.5616 18.2835C1.93416 18.6561 2.43947 18.8654 2.96635 18.8654Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default BriefcaseThinIcon
